import { render, staticRenderFns } from "./AddFormThemes.vue?vue&type=template&id=d760f054&"
import script from "./AddFormThemes.vue?vue&type=script&lang=ts&"
export * from "./AddFormThemes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports